import React from 'react'
import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavItem, NavEntryPoint } from '@retailer-platform/dashboard/routing'
import { NewBadge } from '@retailer-platform/dashboard/gin-and-tonic'
import { roleManagementRouter } from './routing/roleManagementRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import ES_ES from './translations/es-ES.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { RoleManagementAccessControl } from './access-control/roleManagementAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'role-management',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'role-management-dashboard-tool',
  },
  routes,
  translations: { EN_US, ES_ES },
  routers: {
    scoped: [roleManagementRouter],
  },
  navigationEntries: [
    {
      attachTo: NavItem.Admin,
      attachToV2: NavEntryPoint.UserMenuUserManagement,
      subNavItems: [
        {
          type: 'item',
          labelId: 'roleManagementDomain.title',
          route: 'role-management-roles-list',
          accessControl: RoleManagementAccessControl,
          positionNavV2: 1,
          subRoutes: [
            'role-management-role-assigned-users',
            'role-management-role-permissions',
            'role-management-create-role',
            'role-management-edit-role',
          ],
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
